module.exports = __webpack_public_path__ + "img/principles.925c18f6.jpg";